import react from 'react';
const { createElement: rc } = react;
import { BrowserRouter } from 'react-router-dom';

export default function Router(props) {
    const { history, children } = props || {};
    return rc(BrowserRouter, { history }, children);
}
